export default class StorageManager
{
    static has(key)
    {
        return Object.prototype.hasOwnProperty.call(localStorage, key);
    }

    static get(key)
    {
        return localStorage.getItem(key);
    }

    static set(key, value)
    {
        localStorage.setItem(key, value);
    }

    static delete(key)
    {
        localStorage.removeItem(key);
    }
}
